// Dropdown filter options
export const dateFilterOptions = [
  { label: "Last 3 days", value: "last_3_days" },
  { label: "Last 7 days", value: "last_7_days" },
  { label: "Last 30 days", value: "last_30_days" },
  { label: "Custom", value: "custom" },
];

// Table columns
export const intakeTableColumns = [
  { key: "customer_name", label: "Applicant Name" },
  { key: "lob", label: "Line Of Business" },
  { key: "agent_name", label: "Agent" },
  {
    key: "application_classification",
    label: "Classification",
  },
  { key: "application_status", label: "Status" },
  { key: "priority", label: "Priority" },
  { key: "date", label: "Effective Date" },
  { key: "application_id", label: "Application ID" },
  { key: "dnw_decision", label: "DNW decision" },
];

// excludedKeys
export const excludedKeys = ["company_details"];

export const dateFilterData = {
  selected: "date",
  text: "",
  filterBy: "",
  startDate: null,
  endDate: null,
};

export const detailsKeywords = ["summary", "snapshot"];
